import { React } from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

function PassAlert(props) {
    return (
        <Popup open={true} position={"right center"} closeOnEscape={false} closeOnDocumentClick={false}>
            <div id={'popup-alert'} style={{padding: '50px', textAlign: 'center'}} >
                You have potentially entered your <b>password</b> into the chat!<br/>
                CAT will never ask for your <b>password</b> information.<br/> 
                Please remove any password information from the chat for your security.<br/><br/>
                Visit <a href="https://cat.pdx.edu/cram">CRAM</a> to reset or manage your MCECS password. <br/>
                <br/>
                <button style={{margin: '15px'}} onClick={() => {props.closePassAlert()}} className="btn btn-danger">
                    Close 
                </button>
            </div>
        </Popup>
    )
}

export default PassAlert;